import {
  FETCH_CONVERSATIONS_REQUEST,
  FETCH_CONVERSATIONS_SUCCESS,
  FETCH_CONVERSATIONS_FAILURE,
  UPSERT_CONVERSATION_AT_TOP,
} from "../actions/ConversationList.action";

const initialState = {
  loading: false,
  conversations: [],
  totalCount: 0,
  currentPage: 1,
  lastPageHadData: true,
  error: null,
};

export const conversationListReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CONVERSATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_CONVERSATIONS_SUCCESS: {
      const isFirstPage = action.payload.currentPage === 1;
      const newConversations = action.payload.conversations || [];
      
      let updatedConversations;
      if (isFirstPage) {
        updatedConversations = newConversations;
      } else {
        // Create a Set of existing conversation IDs for fast lookup
        const existingIds = new Set(state.conversations.map(c => c.id));
        // Filter out duplicates from new conversations
        const uniqueNewConversations = newConversations.filter(c => !existingIds.has(c.id));
        // Append only unique conversations
        updatedConversations = [...state.conversations, ...uniqueNewConversations];
      }
      
      return {
        ...state,
        loading: false,
        conversations: updatedConversations,
        totalCount: action.payload.totalCount,
        currentPage: action.payload.currentPage,
        lastPageHadData: action.payload.hasMoreData,
      };
    }
    case FETCH_CONVERSATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPSERT_CONVERSATION_AT_TOP: {
      const newConv = action.payload;
      const existing = state?.conversations?.filter((c) => c?.id !== newConv.id);
      // If existing length equals original length, nothing was filtered out = new conversation
      const isNewConversation = existing.length === state.conversations.length;

      return {
        ...state,
        conversations: [newConv, ...existing],
        totalCount: isNewConversation ? state.totalCount + 1 : state.totalCount,
      };
    }
    default:
      return state;
  }
};
